import type { Tenant } from '@core/Entities/App/Tenants.entity';
import type { Locale } from '@core/Entities/Locale/Locale.entity';
import type { AllFlags } from '@growthBookExperimentation/Entities/FlagKeys.entities';

export function getEnabledToggleConfig({
  locale: _locale,
  flags: _flags,
  tenant,
}: {
  locale: Locale;
  tenant?: Tenant;
  flags: AllFlags;
}) {
  return {
    ecom: false,
    eligibleProductsUk: false,
    eligibleProductsFr: false,
    partnerRac: tenant === 'rac',
  };
}
